import { Auth } from 'aws-amplify';
import AWS from 'aws-sdk';

export const initAWSCredentials = async () => {
  // Vérifie qu'il y a bien un user connecté
  await Auth.currentSession(); // throw si pas loggué

  const credentials = await Auth.currentCredentials();
  console.log("CREDENTIALS récupérés : ", credentials);

  AWS.config.update({
    region: process.env.REACT_APP_REGION,
    credentials: Auth.essentialCredentials(credentials),
  });
};
